import React from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { useWidgetContext } from 'widgets/WidgetContext';

import { venueAnalysisStreamedDataSelectors } from 'widgets/venueAnalysis/store/stream/streamSlice';
import { getVenueAnalysisData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import { VenueAnalysisCapsuleConfigState } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';
import { VenueExecCapsuleContent } from 'widgets/venueAnalysis/capsules/venueExecCapsule/components/content/VenueExecCapsuleContent';
export function VenueExecCapsuleMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol } = props;
    const { config, dispatchConfigChanged } =
        useMyPortfolioCapsuleConfigSlice<VenueAnalysisCapsuleConfigState>();

    const { widgetKey } = useWidgetContext();
    const { useSymbolStreamedData } = venueAnalysisStreamedDataSelectors;

    const streamData = useSymbolStreamedData(symbol, config);
    const data = getVenueAnalysisData(
        streamData,
        undefined,
        config.includePreviousDaysFills
    );

    return (
        <VenueExecCapsuleContent
            data={data}
            config={config}
            dispatchConfigChanged={dispatchConfigChanged}
            symbol={symbol}
            capsuleKey={`${widgetKey}=${symbol}`}
            showOrderData={false}
        />
    );
}
